// extracted by css-extract-rspack-plugin
export default {"root":"ClauseStep-module__root___L3t8L","label":"ClauseStep-module__label___jsN41"};